import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CodeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M14.2 3c.6.2.9.7.8 1.2l-4 16a1 1 0 1 1-2-.4l4-16a1 1 0 0 1 1.2-.8ZM6.7 7.3c.4.4.4 1 0 1.4L3.4 12l3.3 3.3a1 1 0 1 1-1.4 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.4 0Zm10.6 0a1 1 0 0 1 1.4 0l4 4c.4.4.4 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.3-3.3-3.3-3.3a1 1 0 0 1 0-1.4Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CodeIcon;
